/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Office_LogoutInputs */

const en_office_logout = /** @type {(inputs: Office_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign out`)
};

const fr_office_logout = /** @type {(inputs: Office_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déconnexion`)
};

const ms_sg2_office_logout = /** @type {(inputs: Office_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log keluar`)
};

/**
* | output |
* | --- |
* | "Sign out" |
*
* @param {Office_LogoutInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const office_logout = /** @type {((inputs?: Office_LogoutInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Office_LogoutInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_office_logout(inputs)
	if (locale === "fr") return fr_office_logout(inputs)
	return ms_sg2_office_logout(inputs)
});